<template>
  <v-container fluid class="categorias-container">
    <v-data-table
      mobile-breakpoint="900"
      class="elevation-1"
      color="primary"
      :calculate-widths="true"
      :headers="categoriesTblHeaders"
      :items="categorias"
      :search="categorySearch"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      show-expand
      :footer-props="dataTableFooterProps"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Categorias</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="categorySearch"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar categoria"
            class="mx-4"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="newCategoryDialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" rounded dark class="mb-2" v-on="on"
                >+</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Agregar Categoría</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="newCategory.categoria"
                        label="Nombre Categoria"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="newCategory.tipo"
                        :items="tipos"
                        label="Tipo*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="newCategory.descripcion"
                        label="Descripcion"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="newCategory.unidad"
                        :items="unidades"
                        label="Unidad*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        type="text"
                        v-model="newCategory.codigo"
                        label="Código*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="newCategory.minimo"
                        label="Mínimo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template item.action="{ item }">
                  <v-btn color="blue darken-1" text @click="closeCreateDialog"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="saveNew()"
                    >Save</v-btn
                  >
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="editCategoryDialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="editedCategory.categoria"
                        label="Nombre Categoria"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedCategory.tipo"
                        :items="tipos"
                        label="Tipo*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedCategory.descripcion"
                        label="Descripcion"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="editedCategory.unidad"
                        :items="unidades"
                        label="Unidad*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        type="text"
                        v-model="editedCategory.codigo"
                        label="Código*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="editedCategory.minimo"
                        label="Mínimo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEditDialog"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="saveEdited()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item }">
        <span>{{
          categorias
            .map(function (x) {
              return x.id;
            })
            .indexOf(item.id) + 1
        }}</span>
      </template>
      <template v-slot:item.imagen="{ item }">
        <TableRowImage :imageUrl="item.imagen" />
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td style="text-align: center" :colspan="headers.length">
          {{ item.descripcion }}
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="categories__table__actions-col">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="red" small @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import TableRowImage from "../components/TableRowImage";
import uiMixin from "../mixins/mixin-ui";
//placed in the window object by the preload and available in the global context
// const { saveNew, getCategoriasAll, updateCategoryByID, deleteCategoriaByID } =
//   api.services.categoriasService;
export default {
  name: "Categorias",
  mixins: [uiMixin],
  components: {
    TableRowImage,
  },
  data: function () {
    return {
      expanded: [],
      singleExpand: true,
      newCategoryIMG: null,
      rules: [
        (value) =>
          !value || value.size < 2000000 || "La imagen debe ser menor a 2 MB!",
      ],
      unidades: ["kilo", "pieza", "carga", "par", "docena"],
      tipos: ["servicios", "productos"],
      calculateWidths: true,
      categorySearch: "",
      editCategoryDialog: false,
      newCategoryDialog: false,
      categoriesTblHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Imagen",
          align: "left",
          sortable: false,
          value: "imagen",
        },
        {
          text: "Codigo",
          align: "left",
          sortable: false,
          value: "codigo",
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "categoria",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Minimo",
          align: "left",
          sortable: true,
          value: "minimo",
        },
        {
          text: "Unidad",
          align: "left",
          sortable: true,
          value: "unidad",
        },
        {
          text: "Fecha",
          align: "left",
          sortable: true,
          value: "fecha",
        },
        { text: "Más", value: "data-table-expand" },
        {
          text: "Admin",
          align: "left",
          sortable: false,
          value: "action",
        },
      ],
      categories: [],
      editedIndex: -1,
      editedCategory: {
        codigo: 0,
        categoria: "",
        tipo: "",
        minimo: 0,
        unidad: "",
        imagen: "",
      },
      newCategory: {
        codigo: 0,
        categoria: "",
        tipo: "",
        minimo: 0,
        unidad: "",
        imagen: "",
      },
      defaultItem: {},
    };
  },
  computed: {
    ...mapGetters(['demoCategorias']),
    newCategoryData: {
      get: function () {
        return this.newCategory;
      },
      set: function (data) {
        this.newCategory = data;
      },
    },
    editedCategoryData: {
      get: function () {
        return this.editedCategory;
      },
      set: function (data) {
        this.editedCategory = data;
      },
    },
    newCategoryIsValid: {
      get: function () {
        const validCategory =
          this.newCategory.categoria === null
            ? false
            : this.newCategory.categoria === ""
            ? false
            : true;
        const validImage = true; //TODO: I need write a function to check that it is a valid url
        return validCategory && validImage;
      },
      set: function () {},
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Categoria" : "Editar Categoria";
    },
    categorias: {
      get: function () {
        return this.categories;
      },
      set: function (payload) {
        this.categories = payload;
      },
    },
  },
  methods: {
    saveNewCategoria(){},
    getCategoriasAll(){ return this.demoCategorias; },
    updateCategoryByID(){},
    deleteCategoriaByID(){},
    fetchCategories() {
      this.categorias = this.getCategoriasAll();
    },
    editItem(item) {
      this.editedIndex = this.categorias.indexOf(item);
      this.editedCategory = Object.assign({}, item);
      this.editCategoryDialog = true;
    },
    deleteItem(item) {
      const index = this.categorias.indexOf(item);
      const confirmation =
        confirm(
          `Seguro quieres borrar el servicio: ${item.codigo} ${item.descripcion}?`
        ) && this.categorias.splice(index, 1);
      const { id } = item;
      if (confirmation) this.deleteCategoriaByID(id);
    },
    closeEditDialog() {
      this.editCategoryDialog = false;
    },
    closeCreateDialog() {
      this.newCategoryDialog = false;
    },
    saveEdited() {
      // const imgName = Utils.removeSpecialChars( this.editedCategoryData.descripcion ).split(' ').join('_').toLowerCase();
      // if(this.newCategoryIMG) this.editedCategoryData.imagen = ImagesService.getImageUrl( this.newServiceIMG, imgName, "servicios" );
      const info = this.updateCategoryByID(this.editedCategory);
      if (info) {
        this.fetchCategories();
        this.resetEditedCategory();
        this.newServiceIMG = null;
        this.closeEditDialog();
      }
    },
    resetNewCategory() {
      this.newCategoryData = {
        codigo: 0,
        categoria: "",
        tipo: "",
        minimo: 0,
        unidad: "",
        imagen: "",
      };
    },
    resetEditedCategory() {
      this.editedCategoryData = {
        codigo: 0,
        categoria: "",
        tipo: "",
        minimo: 0,
        unidad: "",
        imagen: "",
      };
    },
    saveNew() {
      if (this.newCategoryIsValid) {
        // const imgName =  Utils.removeSpecialChars( this.newCategoryData.descripcion ).split(' ').join('_').toLowerCase();
        // if (this.newServiceIMG) this.newCategoryData.imagen = ImagesService.getImageUrl( this.newServiceIMG, imgName, "servicios" );
        const info = this.saveNewCategoria(this.newCategoryData);
        if (info) {
          this.categorias = this.getCategoriasAll();
          this.resetNewCategory();
          // this.newServiceIMG = null;
        }
      } else console.log("category is not valid!");
      this.closeCreateDialog();
    },
  },
  mounted() {
    this.fetchCategories();
  },
};
</script>

<style scoped>
.categorias-container {
  margin-top: 10px;
}

.categories__table__actions-col {
  display: flex;
  flex-wrap: nowrap;
}
</style>